import querystring from 'querystring'
import _ from 'lodash'

import { createAction } from 'redux-actions'

import { actionCreators as api } from 'reduxBits/api'
import { actionCreators as notificationsActionCreators } from 'reduxBits/notifications'

const prefix = 'Geolocation:'
export const REQUEST_GEOLOCATION = `${prefix} Requesting geo location.`
export const RECEIVE_GEOLOCATION = `${prefix} Receive geo location.`
export const SET_PERMISSION = `${prefix} Set permission.`
export const GEOLOCATION_CLICKED = `${prefix} Geo location clicked.`

const requestGeolocation = createAction(REQUEST_GEOLOCATION)
const receiveGeolocation = createAction(RECEIVE_GEOLOCATION)
const setPermission = createAction(SET_PERMISSION)
const geolocationClicked = createAction(GEOLOCATION_CLICKED)

const fetchGeolocation = () => async (dispatch) => {
  let position
  let geolocation

  dispatch(requestGeolocation())

  try {
    position = await new Promise((resolve, reject) => {
      window.navigator.geolocation.getCurrentPosition(
        (result) => resolve(_.pick(result.coords, ['longitude', 'latitude'])),
        (error) => reject(error),
      )
    })

    dispatch(setPermission(true))
  } catch (error) {
    if (typeof error.code !== 'undefined' && error.code === error.PERMISSION_DENIED) {
      dispatch(setPermission(false))
      return dispatch(receiveGeolocation(error))
    }

    dispatch(notificationsActionCreators.addErrorNotification('Kunde inte hitta din plats.'))
    return dispatch(receiveGeolocation(error))
  }

  const geoUrl = `geo.json?${querystring.stringify(position)}`
  const response = await dispatch(api.templateApiFetch(geoUrl))

  if (response.ok) {
    const result = response.textOrJson

    geolocation = {
      r: result.region,
      m: result.munic,
      sa: result.subarea,
    }

    dispatch(receiveGeolocation(geolocation))
    return geolocation
  }

  dispatch(notificationsActionCreators.addErrorNotification('Kunde inte hitta din plats.'))
  return dispatch(receiveGeolocation(response))
}

export const actionCreators = {
  fetchGeolocation,
  geolocationClicked,
}
